"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Msal = require("msal");
require("../Utils/Extensions");
var EventHandlerService_1 = require("./EventHandlerService");
var Types_1 = require("../Types");
var Util_1 = require("./Util");
var Endpoints_1 = require("../Utils/Endpoints");
var AuthenticationState;
(function (AuthenticationState) {
    AuthenticationState[AuthenticationState["Unauthenticated"] = 0] = "Unauthenticated";
    AuthenticationState[AuthenticationState["Loading"] = 1] = "Loading";
    AuthenticationState[AuthenticationState["Authenticated"] = 2] = "Authenticated";
    AuthenticationState[AuthenticationState["PasswordReset"] = 3] = "PasswordReset";
    AuthenticationState[AuthenticationState["TwoFactor"] = 4] = "TwoFactor";
    AuthenticationState[AuthenticationState["LicenseError"] = 5] = "LicenseError";
    AuthenticationState[AuthenticationState["Error"] = 6] = "Error";
})(AuthenticationState = exports.AuthenticationState || (exports.AuthenticationState = {}));
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService() {
        var _this = this;
        var _a;
        this.errorKey = "msal.login.error";
        this.passwordResetKey = "password.reset";
        this.editProfileKey = "edit.profile";
        this.twoFactorKey = "2fa.code";
        this.authCallback = function (authErr, response) {
            if (authErr) {
                console.error(authErr);
                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteErrorEvent(authErr.message + " " + _this.resources.IfThisProblemPersists + " " + _this.resources.VeriLiteSupportEmail, _this.resources.AuthenticationError, []));
            }
        };
        this.readErrorFromSession = function () {
            var error = sessionStorage.getItem(_this.errorKey);
            return error;
        };
        this.refreshAccessToken = function () {
            //console.log("refreshAccessToken");
            return new Promise(function (resolve, reject) {
                _this.authClient.acquireTokenSilent(_this.tokenRequest)
                    .then(function (tokenReponse) {
                    _this.accessToken = tokenReponse.accessToken;
                    _this.sessionExpiry = tokenReponse.expiresOn.getTime();
                    resolve(_this.accessToken);
                }).catch(function (error) {
                    console.error(error);
                    _this.accessToken = "";
                    reject(error);
                });
            });
        };
        this.getAccessToken = function () {
            return new Promise(function (resolve, reject) {
                if (String.isNullOrWhitespace(_this.accessToken)) {
                    _this.refreshAccessToken().then(function (newToken) {
                        resolve(newToken);
                    }).catch(function (error) {
                        reject("Unable to retrieve access token: " + error);
                    });
                }
                else {
                    resolve(_this.accessToken);
                }
            });
        };
        this.logout = function () {
            sessionStorage.removeItem(AuthenticationService.selectedLocationKey);
            _this.authClient.logout();
        };
        this.getUser = function () {
            var userToken = _this.authClient.getAccount().idToken;
            return {
                name: userToken.name,
                Location: userToken.extension_Location,
                Organisation: userToken.extension_Organization,
                TwoFactorEnabled: Util_1.parseBoolean(userToken.extension_TwoFactorAuthentication),
                PasswordReset: Util_1.parseBoolean(userToken.extension_PasswordReset),
                id: userToken.oid
            };
        };
        this.passwordReset = function () {
            _this.authClient.authority = process.env.REACT_APP_RESETPASSWORD || "";
            sessionStorage.setItem(_this.passwordResetKey, 'true');
            _this.authClient.loginRedirect(_this.loginRequest);
        };
        this.editProfile = function () {
            _this.authClient.authority = process.env.REACT_APP_EDITPROFILE || "";
            sessionStorage.setItem(_this.editProfileKey, 'true');
            _this.authClient.loginRedirect(_this.loginRequest);
        };
        this.reAuthenticateAfterPasswordReset = function () {
            sessionStorage.setItem(_this.passwordResetKey, 'false');
            _this.logout();
        };
        this.setError = function () {
            _this._state = AuthenticationState.Error;
        };
        this.setLicenseError = function () {
            _this._state = AuthenticationState.LicenseError;
        };
        this.twoFactorComplete = function (code) {
            _this._state = AuthenticationState.Authenticated;
            sessionStorage.setItem(_this.twoFactorKey, code);
        };
        this.validateCodeAsync = function (code) { return __awaiter(_this, void 0, void 0, function () {
            var body;
            var _this = this;
            return __generator(this, function (_a) {
                body = JSON.stringify({ code: code });
                return [2 /*return*/, new Promise(function (res) {
                        return Util_1.postJson(Endpoints_1.default.ValidateTwoFactorCode, body, undefined, true, new Util_1.UserRequestHeaders(_this.getUser()))
                            .then(function (response) {
                            res(response);
                        });
                    })];
            });
        }); };
        this.getTwoFactorCode = function () {
            return sessionStorage.getItem(_this.twoFactorKey);
        };
        this.getError = function () {
            return sessionStorage.getItem(_this.errorKey) || "";
        };
        this.initLogoutTimer = function () {
            _this.secondsIdle = 0;
            setInterval(_this.tickLogoutTimer, 1000);
            document.addEventListener("mousemove", _this.resetLogoutTimer, true);
        };
        this.resetLogoutTimer = function () {
            _this.secondsIdle = 0;
        };
        this.tickLogoutTimer = function () {
            _this.secondsIdle++;
            if (_this.secondsIdle === 20) {
                _this.refreshAccessToken()
                    .catch(function (e) {
                    return console.error(e);
                });
            }
            if (Date.now() >= _this.sessionExpiry) {
                _this.logout();
            }
        };
        this.checkSessionState = function (key) {
            var sessionState = sessionStorage.getItem(key);
            return sessionState === 'true';
        };
        this.resources = {};
        Util_1.GetResources(function (resources) { _this.resources = resources; });
        this.appConfig = {
            b2cScopes: [process.env.REACT_APP_B2CSCOPES || ""],
            webApi: process.env.REACT_APP_WEBAPI || ""
        };
        this.msalConfig = {
            auth: {
                clientId: process.env.REACT_APP_CLIENTID || "",
                authority: process.env.REACT_APP_SIGNUPSIGNIN || "",
                validateAuthority: false,
                postLogoutRedirectUri: process.env.REACT_APP_WEBAPI || ""
            },
            cache: {
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false
            }
        };
        this.loginRequest = {
            scopes: this.appConfig.b2cScopes,
            redirectUri: process.env.REACT_APP_WEBAPI || ""
        };
        this.tokenRequest = {
            scopes: this.appConfig.b2cScopes,
            redirectUri: process.env.REACT_APP_WEBAPI || "",
            forceRefresh: true
        };
        this.accessToken = "";
        this.secondsIdle = 0;
        this.sessionExpiry = 0;
        this.authClient = new Msal.UserAgentApplication(this.msalConfig);
        this.authClient.handleRedirectCallback(this.authCallback);
        this.isCallback = this.authClient.isCallback(window.location.hash);
        this.hasError = sessionStorage.getItem(this.errorKey) !== null;
        this.isAuthenticated = this.authClient.getAccount() !== null;
        this.isPasswordReset = this.checkSessionState(this.passwordResetKey);
        this.isEditProfile = this.checkSessionState(this.editProfileKey);
        if (this.isCallback) {
            this._state = AuthenticationState.Loading;
        }
        else if (this.hasError) {
            this._state = AuthenticationState.Error;
            var error = sessionStorage.getItem(this.errorKey);
            console.error(error);
            if (this.isPasswordReset) {
                this._state = AuthenticationState.PasswordReset;
            }
            else if ((_a = error) === null || _a === void 0 ? void 0 : _a.startsWith("AADB2C90118")) {
                sessionStorage.removeItem(this.errorKey);
                this.passwordReset();
            }
        }
        else if (this.isAuthenticated) {
            this._state = AuthenticationState.Authenticated;
        }
        else {
            this._state = AuthenticationState.Unauthenticated;
        }
    }
    Object.defineProperty(AuthenticationService.prototype, "State", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    AuthenticationService.prototype.init = function (locationSetCallback) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!!this.isAuthenticated) return [3 /*break*/, 1];
                        if (this.hasError) {
                            console.error(sessionStorage.getItem(this.errorKey));
                        }
                        else {
                            this.authClient.loginRedirect(this.loginRequest);
                        }
                        return [3 /*break*/, 7];
                    case 1:
                        if (!!this.isCallback) return [3 /*break*/, 7];
                        if (!this.isEditProfile) return [3 /*break*/, 2];
                        sessionStorage.setItem(this.editProfileKey, 'false');
                        sessionStorage.removeItem(this.errorKey);
                        this.authClient.loginRedirect(this.loginRequest);
                        return [3 /*break*/, 7];
                    case 2:
                        if (!this.isPasswordReset) return [3 /*break*/, 3];
                        this._state = AuthenticationState.PasswordReset;
                        return [3 /*break*/, 7];
                    case 3:
                        if (!this.getUser().PasswordReset) return [3 /*break*/, 4];
                        this.passwordReset();
                        return [3 /*break*/, 7];
                    case 4:
                        _a = this.getUser().TwoFactorEnabled;
                        if (!_a) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.validateCodeAsync(this.getTwoFactorCode() || "")];
                    case 5:
                        _a = !(_b.sent()).isValid;
                        _b.label = 6;
                    case 6:
                        if (_a) {
                            this._state = AuthenticationState.TwoFactor;
                        }
                        else {
                            //the idToken exp value is in seconds and we want miliseconds
                            this.sessionExpiry = Number(this.authClient.getAccount().idToken.exp) * 1000;
                            this.initLogoutTimer();
                            //console.log(`Setting session storage with users default location: ${this.getUser().Location}`);
                            if (sessionStorage.getItem(AuthenticationService.selectedLocationKey) == null) {
                                sessionStorage.setItem(AuthenticationService.selectedLocationKey, this.getUser().Location);
                                locationSetCallback(this.getUser().Location);
                            }
                        }
                        _b.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    AuthenticationService.selectedLocationKey = "selectedLocation";
    return AuthenticationService;
}());
exports.AuthenticationService = AuthenticationService;
exports.Auth = new AuthenticationService();
//# sourceMappingURL=AuthenticationService.js.map